<div class="row">
    <div class="col-md-12">
        <nb-card>
            <nb-card-header>
                {{title}}
                <div class="buttons-row float-right">
                    <button type="button"  class="appearance-filled" (click)="onList()"  [size]="'small'" [status]="'primary'"
                      nbButton>List</button>
                  </div>
            </nb-card-header>
            <nb-card-body>
                <form [formGroup]="companyGroupForm" class="form-valide">
                <div class="row">
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label for="GroupName" class="label">Group name</label>
                            <input type="text" maxlength="100" trim="blur" nbInput fullWidth formControlName="GroupName" [(ngModel)]='cgName'
                                fieldSize="small">
                                <ng-container *ngIf="submitted && f.GroupName.errors" class="invalid-feedback">
                                    <p class="caption status-danger" *ngIf="f.GroupName.errors.required">Group name is required</p>
                                  </ng-container>
                        </div>
                    </div>
                    <div class="col-sm-5">
                        <div class="form-group">
                            <label for="Companies" class="label">Select companies</label>
                            <nb-select multiple placeholder="Multiple Select" [size]="'small'" fullWidth formControlName="CompanyNames" 
                            [ngModel]="custMasterList" (selectedChange)="selectedCompanies($event)" (selected)="custMasterList">
                                <nb-option *ngFor="let item of allCustArr" [value]="item.custId">
                                    {{item.customerName}} ({{item.custCode}})</nb-option>
                              </nb-select>
                              <ng-container *ngIf="submitted && f.CompanyNames.errors" class="invalid-feedback">
                                <p class="caption status-danger" *ngIf="f.CompanyNames.errors.required">Select atleast one company</p>
                              </ng-container>
                        </div>
                    </div>
                </div>
                <div class="buttons-row float-right">
                    <button type="button" (click)="onSubmit()" class="appearance-filled"
                      [size]="'small'" [status]="'success'" nbButton [class.disabledBtn]="loading">
                      <nb-icon nbPrefix class="fa fa-spinner fa-spin" pack="font-awesome"></nb-icon>Save</button>
                    <button type="button" [disabled]="isDisabled" (click)="onReset()" class="appearance-outline"
                      [size]="'small'" [status]="'info'" nbButton>Reset</button>
                  </div>
            </form>
            </nb-card-body>
        </nb-card>
    </div>

</div>
